import React from "react";
import { ICategory } from "../../../../types/category.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  category: ICategory;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewCategoryForm: React.FC<Props> = (props) => {
  return (
    <div>
      <div className={styles.form}>
        <ViewInput title="Опис" value={props.category.description} isBig />
      </div>
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewCategoryForm;
